
import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'app-ratgeber-page',
  imports: [RouterLink],
  templateUrl: './ratgeber-page.component.html',
  styleUrl: './ratgeber-page.component.scss'
})
export class RatgeberPageComponent {
  content;
  constructor(
    private route: ActivatedRoute,
    private metaTagService: Meta,
    private titleService: Title
  ) {
    this.content = this.route.snapshot.data.content;
    this.titleService.setTitle(this.content.title);
    this.metaTagService.updateTag(
      { name: 'description', content: this.content.description },
      'name=description'
    );
  }
}
